import state from "./moduleSkillsState.js";
import mutations from "./moduleSkillsMutations.js";
import actions from "./moduleSkillsActions.js";
import getters from "./moduleSkillsGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
